import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Utility } from '../../core/utils/utility';
import { BehaviorSubject, Observable, Subject, map, tap } from 'rxjs';
import { AuthService } from '../../auth/_services/auth.service';
import { SignalrService } from './signalr.service';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {


  count$: Subject<number> = new Subject<number>();
  countByChat$: Subject<number> = new Subject<number>();
  countByChat: any;

  apiUrl: string = `${environment.apiUrl}/message`;

  constructor(
    private http: HttpClient,
    signalR: SignalrService
  ) {
    signalR.messageCountChanged.subscribe((message: any) => {
      this.getAllCount().subscribe();

      if (message !== null && message !== undefined) {
        for (const key in this.countByChat) {
          if (Object.prototype.hasOwnProperty.call(this.countByChat, key)) {
            let element = this.countByChat[key];
            if (message.chatId == key) {
              element += 1;
              break;
            }
          }
        }
        this.countByChat$.next(this.countByChat);
      }
    });
  }

  send(model: any) {
    return this.http.post<any>(`${this.apiUrl}`, model);
  }

  sendFile(model: any) {
    let formData = Utility.objectToFormData(model);

    let options: any = {
      reportProgress: true,
      observe: "events",
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.post(`${this.apiUrl}/file`, formData, options)
      .pipe(
        map((event: any) => {
          let progress = 0;
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                progress = Math.round((100 * event.loaded) / event.total);
              }
              return { status: "progress", message: progress };

            case HttpEventType.Response:
              return event;
            default:
              return `Unhandled event: ${event.type}`;
          }
        })
      );
  }

  get(tableState: any) {
    let params = Utility.tableStateToHttpParams(tableState);
    return this.http
      .get<any>(`${this.apiUrl}`, { params: params }).pipe(
        tap(res => {
          Utility.addUTCDesignatorRecurse(res);
        })
      );
  }

  getAllCount(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/getcount`).pipe(tap((x: any) => {
      this.countByChat = x;
      let s = 0;
      for (const key in x) {
        if (Object.prototype.hasOwnProperty.call(x, key)) {
          const element = x[key];
          s += element;
        }
      }
      this.count$.next(s);
      this.countByChat$.next(this.countByChat);
    }));
  }

  getAttachment(id: any) {
    return this.http.get(`${this.apiUrl}/attachment/${id}`, { responseType: 'blob' });
  }
}
